const umStudioLogo = require('../../../assets/images/logos/umStudioLogo.svg');

/*@ngInject*/
const AppHeaderController = function ($scope, localization, coreMediator, modalUtil, authenticationMediator, currentUserModel,
                                      authorizationConstants, userLoginType) {

    $scope.umStudioLogoPath = umStudioLogo;

        $scope.viewModel = {
            hasViewDetailHistoryPermission: false,
            hasManageBackupRestorePermission: false,
            hasManageImportDataPermission:false,
            hasGenerateDataDictionaryPermission:false
        };

        $scope.viewModel.hasViewDetailHistoryPermission = currentUserModel.hasAuthorization(authorizationConstants.VIEW_CONFIG_DETAILED_HISTORY);

        $scope.viewModel.hasManageBackupRestorePermission = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_BACKUP_RESTORE);

        $scope.viewModel.hasManageImportDataPermission = currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_IMPORT_DATA);

        $scope.viewModel.hasGenerateDataDictionaryPermission = currentUserModel.hasAuthorization(authorizationConstants.AUTHORIZATION_GENERATE_DATA_DICTIONARY);

    function init() {

        localization.getTranslationByKey('appHeader').then(function (translations) {

                var profileMenuItem = {
                        identifier: 'profile',
                        enabled: true,
                        iconClass: 'glyphicon-user',
                        label: _.get(translations, 'userProfileDropdown.menuItems.profile'),
                        action: showUserProfile
                    },
                    logoutMenuItem = {
                        identifier: 'logout',
                        enabled: true,
                        iconClass: 'glyphicon-log-out',
                        label: _.get(translations, 'userProfileDropdown.menuItems.logout'),
                        action: logout
                    };

                $scope.viewModel.menuItems = [
                    profileMenuItem,
                    logoutMenuItem
                ];

                coreMediator.loadDefaultPreferences().then(function (preferences) {
                    var changePasswordMenuItem;

                    if (preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false' &&
                        currentUserModel.getCurrentUser().loginType !== userLoginType.SINGLE_SIGN_ON) {
                        changePasswordMenuItem = {
                            identifier: 'changePassword',
                            enabled: true,
                            iconClass: 'glyphicon-lock',
                            label: _.get(translations, 'userProfileDropdown.menuItems.changePassword'),
                            action: showChangePassword
                        };

                        $scope.viewModel.menuItems.splice(1, 0, changePasswordMenuItem);
                        $scope.viewModel.menuItems.join();
                    }
                }.bind(this));
            });
        }

    function showUserProfile() {
        modalUtil.showUserProfile();
    }

    function showChangePassword() {
        authenticationMediator.showChangePasswordPopup();
    }

    function logout() {
        coreMediator.logout();
    }

    init();
};

angular.module('ums')
    .controller('appHeaderController', AppHeaderController);
